import { render, staticRenderFns } from "./mobanChuzhika.vue?vue&type=template&id=01de02ca&scoped=true"
import script from "./mobanChuzhika.vue?vue&type=script&lang=js"
export * from "./mobanChuzhika.vue?vue&type=script&lang=js"
import style0 from "./mobanChuzhika.vue?vue&type=style&index=0&id=01de02ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de02ca",
  null
  
)

export default component.exports